import styles from "../style";
import heroVideo from "../assets/hero_vedio.mp4";
import { useState } from "react";

import { useTypewriter } from "react-simple-typewriter";

const Hero = () => {
  const [text] = useTypewriter({
    words: ["Build Your Brand"],
    loop: {},
  });
  // Hero CTA handlers removed — CTAs live in the floating nav now.

  return (
    <>
      {/* spacer anchor so the fixed floating nav doesn't cover the hero */}
      <div id="home" className="nav-spacer" />
      <section id="home-section" className={`flex md:flex-col flex-col ${styles.paddingY} ${styles.marginY}`}>
      <div className={`flex-1 ${styles.flexStart} flex-col xl:px-0 sm:px-16 px-6`}>
        <div className="flex flex-col justify-between items-center w-full">
          <h1 className="flex-1 md:w-10/12 text-center font-poppins font-semibold ss:text-[52px] text-[30px] text-white ss:leading-[64px] leading-[40px]">
            Transform Your Opinions & Personality   <br/>Into AI Twin
          </h1>
          <h1 className="text-gradient h-[80px] font-poppins font-semibold ss:text-[46px] text-[28px]">{text}</h1>
        </div>

        {/* Intro video placed under hero headings */}
        <div className="w-full flex justify-center mt-6 relative">
          <video
            id="hero-video"
            src={heroVideo}
            poster={`${process.env.PUBLIC_URL}/hero-poster.png`}
            className="w-full max-w-4xl h-56 md:h-96 rounded-xl object-cover md:object-top object-center shadow-2xl"
            loop
            playsInline
            aria-label="Intro video"
            style={{ background: 'linear-gradient(180deg,#071014,#05070a)' }}
          />
          {/* Play overlay: accessible button with SVG icon + keyboard support */}
          <VideoPlayerOverlay videoId="hero-video" />
        </div>

  {/* CTAs moved to the floating nav — hero CTA buttons removed to avoid duplication */}
      </div>
  </section>
  </>
  );
};

export default Hero;

// Small overlay component to control the hero video playback and unmute on user action
function VideoPlayerOverlay({ videoId }) {
  const [playing, setPlaying] = useState(false);

  const handlePlay = () => {
    const video = document.getElementById(videoId);
    if (!video) return;
    if (!playing) {
      // attempt to play unmuted — browsers require a user gesture for unmuted playback
      video.muted = false;
      const p = video.play();
      if (p && typeof p.then === 'function') {
        p.then(() => setPlaying(true)).catch(() => {
          // fallback: mute and play if unmuted blocked
          video.muted = true;
          video.play();
          setPlaying(true);
        });
      } else {
        setPlaying(true);
      }
    } else {
      video.pause();
      setPlaying(false);
    }
  };

  const onKey = (e) => {
    if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); handlePlay(); }
  };

  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <button
        className="video-play-btn"
        onClick={handlePlay}
        onKeyDown={onKey}
        aria-pressed={playing}
        aria-label={playing ? 'Pause intro video' : 'Play intro video'}
      >
        {/* Play / Pause SVG */}
        {!playing ? (
          <svg className="video-play-icon" viewBox="0 0 24 24" aria-hidden>
            <path d="M8 5v14l11-7z" />
          </svg>
        ) : (
          <svg className="video-play-icon" viewBox="0 0 24 24" aria-hidden>
            <path d="M6 6h4v12H6zM14 6h4v12h-4z" />
          </svg>
        )}
      </button>
    </div>
  );
}
